import { SxProps } from "@mui/material"

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxSubtitle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C'
}

export const sxTypographyAdvice: SxProps = {
  color: '#4C4C4C',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
  color: '#383838',
  fontFamily: 'UnimedSans-Bold',
  fontSize: '16px',
  fontStyle: 'normal',
  lineHeight: '150%',
}